import { getEventFromValue, PublicLead } from "shared/topchef.types";
import LeadStatusDetails from "pages/shared/lead-status/LeadStatusDetails"

type PublicLeadContentProps = {
  publicLead: PublicLead;
};

const PublicLeadContent = ({ publicLead }: PublicLeadContentProps) => {

  const formattedBudget = (typeof publicLead.budget === 'number' && publicLead.budget > 0) ? publicLead.budget : 'non précisé';


  return (
      <div className="row mt-4">
        <h3 className="mb-3 text-center">Détails du brief</h3>

        <div className="mb-4 text-center">
            <LeadStatusDetails lead={publicLead} />
        </div>

        <div className="mb-3 col-md-6">
            <strong>Date de l'événement :</strong>
            <span id="display_event_date" className="card p-1 bg-light">{publicLead.targetDate.toString()}</span>
        </div>
        <div className="mb-3 col-md-6">
            <strong>Type d'événement :</strong>
            <span id="display_event_type" className="card p-1 bg-light">{getEventFromValue(publicLead.type!).label}</span>
        </div>
        {(publicLead.startTime !=='' && publicLead.endTime !=='') &&
            <>
                <div className="mb-3 col-md-6">
                    <strong>Heure de début :</strong>
                    <span id="display_start_time" className="card p-1 bg-light">{publicLead.startTime}</span>
                </div>
                <div className="mb-3 col-md-6">
                    <strong>Heure de fin :</strong>
                    <span id="display_end_time" className="card p-1 bg-light">{publicLead.endTime}</span>
                </div>
            </>
        }
        <div className="mb-3 col-md-6">
            <strong>Nombre de personnes :</strong>
            <span id="display_guests" className="card p-1 bg-light">{publicLead.guests}</span>
        </div>
        <div className="col-md-6">
            <strong>Budget total :</strong>
            <span id="display_budget" className="card p-1 bg-light">{formattedBudget}</span>
        </div>
        <div className="mb-3 col-md-6">
            <strong>Ville :</strong>
            <span id="display_zipcode" className="card p-1 bg-light">{publicLead.city}</span>
        </div>
        <div className="mb-3 col-md-6">
            <strong>Entreprise :</strong>
            <span id="display_company" className="card p-1 bg-light">{publicLead.contactCompany}</span>
        </div>
        <div className="mb-3 col-md-12">
            <strong>Détails de l'événement :</strong>
            <p id="display_description" className="card p-1 bg-light" style={{whiteSpace: 'pre-line'}}>{publicLead.description} </p>
        </div>
    </div>
  );

}

export default PublicLeadContent;
